import { render, staticRenderFns } from "./agrial-switch.vue?vue&type=template&id=5fe8e4f2&scoped=true"
import script from "./agrial-switch.vue?vue&type=script&lang=js"
export * from "./agrial-switch.vue?vue&type=script&lang=js"
import style0 from "./agrial-switch.vue?vue&type=style&index=0&id=5fe8e4f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fe8e4f2",
  null
  
)

export default component.exports